import React, { useState } from "react";
import Header from "../components/header";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/footer";
import KpiTable from "../components/kpiTable.jsx";
import axiosInstance from "../services/axiosInstance.js";

const Kpi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [kpiList, setKpiList] = useState([]);

  const breadcrumbPaths = [
    { label: "Home", href: "/dashboard" },
    { label: "KPI", href: "/kpi" },
  ];

  const downloadKPIReport = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        "api/UserManagement/dowloadKPIReport",
        {
          responseType: "blob", // Important for handling binary data correctly
        }
      );

      const url = window.URL.createObjectURL(new Blob([response])); // response is the file content

      const link = document.createElement("a");
      link.href = url;

      // Get current date and time in the format YYYYMMDD_HHMMSS
      const now = new Date();
      const dateTime =
        now.getFullYear().toString() +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        now.getDate().toString().padStart(2, "0") +
        "_" +
        now.getHours().toString().padStart(2, "0") +
        now.getMinutes().toString().padStart(2, "0") +
        now.getSeconds().toString().padStart(2, "0");

      link.setAttribute("download", `Orders_Report_${dateTime}.xlsx`);
      document.body.appendChild(link);
      link.click();

      // Cleanup after download
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setIsLoading(false);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <div>
      <Header></Header>
      <div
        className="mx-auto container xl:w-full container p-6 py-16 pt-28 2xl:pt-36
      before:content-[''] before:bottom-0 before:right-0 before:w-[200px] before:h-[220px] before:bg-cover before:bg-right-bottom before:bg-no-repeat before:fixed before:bg-[url('./assets/images/schreiber-right.svg')] before:hidden lg:before:block before:-z-10
      after:content-[''] after:bottom-0 after:left-0 after:w-[200px] after:h-[220px] after:bg-cover after:bg-left-bottom after:bg-no-repeat after:fixed after:bg-[url('./assets/images/schreiber-left.svg')] after:hidden lg:after:block after:-z-10
      "
      >
        <div className="flex justify-between">
          <Breadcrumb paths={breadcrumbPaths} />
        </div>
        <KpiTable
          loading={loading}
          setLoading={setLoading}
          kpiList={kpiList}
          setKpiList={setKpiList}
        />
        <div className="flex justify-end pt-4">
          {!loading && (
            <button
              className={`bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border border-blue 
              ${
                isLoading
                  ? "bg-gray-400 border-gray-400 cursor-not-allowed"
                  : "hover:bg-blue-800 hover:border-blue-800"
              } 
              text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in`}
              type="button"
              onClick={() => downloadKPIReport()}
              disabled={isLoading}
            >
              {isLoading ? "Exportiert" : "Export"}
            </button>
          )}
        </div>
      </div>
      <div className="xl:absolute bottom-0 w-full relative">
        {" "}
        <Footer />{" "}
      </div>
    </div>
  );
};

export default Kpi;
